// extracted by mini-css-extract-plugin
module.exports = {"packshotBackground":"_2O1rBS","packshot":"_2a7NJV","seasonPackshot":"_3lUlm2"};